/**
 * The address customers are told to write to when they want to talk to us — a trial
 * that ran out, an expired contract, a plan limit hit on the usage page.
 *
 * One global setting, seeded by migration 36dfa96d358e with the fallback below, and
 * overridable per tenant (e.g. to point at their account manager). Kept as a constant
 * because the codegen'd documents inline the key as a literal and cannot interpolate.
 * Neptune reads the same key — see neptune/src/lib/constants/salesContact.ts.
 */
export const SALES_CONTACT_EMAIL_SETTING_KEY = "sales_contact_email";
export const SALES_CONTACT_EMAIL_FALLBACK = "sales@lytra.ai";
